var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-animation rounded-full",staticStyle:{"background":"#EA4E4E"},style:({width: (_vm.size + "px"), height: (_vm.size + "px")})})}
var staticRenderFns = []

export { render, staticRenderFns }